module.exports = __webpack_public_path__ + "media/images/ui__arrowUp-8d81cb64da44523e7b60eec1d87d278c.png";